export default "__VITE_ASSET__CSyqa9PW__"